import React from "react";
import { getAdminHomeContact } from "../../actions/contact";
import { connect } from "react-redux";
import { tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import AdminHaut from "../../components/AdminHaut";
import AdminItemMessHome from "../../components/AdminItemMessHome";
import Alert from "../../components/Alert";

class AdminHomeCtct extends React.Component {
    state = {
        menuActive: false,
        opts: [],
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        datas: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.getAdminHomeContact();
            this.setState({
                alert: tempAlWait()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getAdminHomeContact();
                this.setState({
                    alert: tempAlWait()
                })
            }
        }

        if (this.props.redListAdmHome != prevProps.redListAdmHome) {
            this.setState({
                alert: this.props.redListAdmHome.alert,
                datas: this.props.redListAdmHome.datas
            })
        }   
    }
    
    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                changeAlert={(el) => this.setState({alert: el})}
                active={this.state.menuActive}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Contact"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.length == 0 ?
                        <h2 className="admin__empty">Aucun message n'a été envoyé pour le moment.</h2> :
                        <ul className="admin__list">
                            {
                                this.state.datas
                                    .sort((a, b) => {
                                        return new Date(b.date.date) - new Date(a.date.date);
                                    })
                                    .map((data, key) => {
                                    return <AdminItemMessHome
                                        data={data}
                                        key={`mess-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.getAdminHomeContact();
                                            }
                                        }}
                                    />
                                })
                            }
                        </ul>
                }
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redListAdmHome: state.redListAdmHome
    }
}

const mapDispatchToProps = {
    getAdminHomeContact
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHomeCtct);